import { Button } from '@platform/design-system';
import type { Order } from '../orders/orders.ts';
import { usePageContext } from '../usePageContext.ts';
import type { ReturnCandidate } from './returns.ts';
import styles from './Returns.module.css';

export type ReturnCandidatesProps = {
  label: string;
  candidates: readonly ReturnCandidate[];
  inBasket: ReadonlySet<string>;
  statusOf: (order: Order) => string;
  onAdd: (candidate: ReturnCandidate) => void;
};

export const ReturnCandidates = ({ label, candidates, inBasket, statusOf, onAdd }: ReturnCandidatesProps) => {
  const { t } = usePageContext();
  const reasonOf = (candidate: ReturnCandidate): string | null => {
    if (inBasket.has(candidate.order.id)) return t('returns.inBasket');
    return candidate.receivable ? null : t('returns.notReceivableShort');
  };
  return (
    <ul className={styles['received']} aria-label={label}>
      {candidates.map((candidate) => {
        const reason = reasonOf(candidate);
        return (
          <li key={candidate.order.id} className={styles['entryHead']}>
            <span className={styles['stacked']}>
              <strong>{candidate.order.number}</strong>
              <span className={styles['muted']}>
                {candidate.order.customer.name} · {statusOf(candidate.order)}
              </span>
            </span>
            {reason === null ? (
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  onAdd(candidate);
                }}
              >
                {t('returns.addShort')}
              </Button>
            ) : (
              <span className={styles['muted']}>{reason}</span>
            )}
          </li>
        );
      })}
    </ul>
  );
};
